import React, { Component, Fragment } from 'react';
import TreePlot from '../../../../services/Cascade/PowerTree/v2/plot';
import TreeComponent from './component';
import { ColorPicker } from 'antd';
import debounce from '../../../../services/helper/debounceFn';
import { numberCheck } from '../../../../services/helper/dataProcess';
import '../Tree/tree.css';

class TreeCanvas extends Component {

  constructor(props) {
    super(props);
    this.state = {
      height: 800,
      gridWidth: 400,
      gridHeight: 200,
      posUpdate: false,
      columns: 6,
      selectkey: "",
      width: props.width || 1000,
      diffColor: false
    }
  }

  componentDidMount() {
    this.getHeight(true);
    this.props.canvasRef && this.props.canvasRef(this);
  }

  componentDidUpdate = (prevProps) => {
    const { width, drawStatus, connections, includeInd } = this.props;
    if (width !== prevProps.width) {
      this.getHeight(false);
    }

    if (drawStatus) {
      this.props.updateDrawType(false);
      this.brush && this.brush.clear();
      this.getHeight(true);
    }

    if (connections.length !== prevProps.connections.length) {
      this.getHeight(true);
    }

    if (includeInd !== prevProps.includeInd) {
      this.getHeight(false);
    }
  }

  getHeight = (init) => {
    const { branch, width, deep, setting } = this.props;
    const { autoWidth, autoHeight, gridWidth: settingWidth, gridHeight: settingHeight, usePowerColor } = setting;
    const minColumns = autoWidth ? Math.round(width / 280) : Math.round(width / Number(settingWidth));
    const columns = branch.length > minColumns ? branch.length : minColumns;
    const minGridWidth = autoWidth ? 200 : Number(settingWidth);
    const gridWidth = Math.round(width / columns);
    const _gridWidth = gridWidth < minGridWidth ? minGridWidth : gridWidth;
    const gridHeight = autoHeight ? Math.round(0.6 * _gridWidth) : Number(settingHeight);
    const height = gridHeight * deep;
    this.setState({
      height,
      gridWidth: _gridWidth,
      gridHeight,
      columns,
      posUpdate: true,
      width: gridWidth < minGridWidth ? columns * minGridWidth : width - 5,
      diffColor: usePowerColor
    }, () => {
      init ? this.initPlot() : this.resetPlot();
    })
  }

  initPlot = () => {
    const { branch, deep, root, id, pcbIndex, connections, includeInd, mainPCB } = this.props;
    const { height, columns, width, diffColor } = this.state;
    this.brush = new TreePlot({ id: `power-tree-canvas-${id}`, branch, width, deep, root, height, columns, pcbIndex, connections, includeInd, mainPCB, diffColor });
    this.draw();
  }

  resetPlot = () => {
    if (!this.brush) {
      this.initPlot();
    } else {
      const { includeInd, pcbIndex } = this.props;
      const { height, columns, width, diffColor } = this.state;
      this.brush.reDraw({ width, height, columns, includeInd, pcbIndex, diffColor });
      this.draw();
    }
  }

  draw = async () => {
    const { id } = this.props;
    this.updateTip('Drawing Power Tree...');
    debounce(async () => {
      this.brush.clear();
      await this.brush.draw();
      this.updateTip('');
    }, 1000, false, `power-tree-canvas-${id}`)();
  }

  updateTip = (tip) => {
    const { id } = this.props;
    this.props.updateTreeLoading(id, tip)
  }

  updatePosition = (pos) => {
    this.setState({ posUpdate: pos });
  }

  changePCBKeys = (e, key) => {
    e && e.stopPropagation();
    const selectkey = this.state.selectkey;
    let _key = key;
    if (selectkey === _key) {
      _key = ""
    }
    this.setState({
      selectkey: _key
    })
  }

  getCanvas = () => {
    const { id } = this.props;
    return document.getElementById(`power-tree-layout-${id}`);
  }

  stopPropagation = (e) => {
    e && e.stopPropagation()
    e && e.preventDefault()
  }

  changeColor = (value, index) => {
    const color = value.toHexString();
    this.props.colorChange({ target: { value: color } }, index)
  }

  checkDeep = (columnIndex, newDeep, except = []) => {
    const numberError = numberCheck(newDeep);
    if (numberError) {
      return 'Vertical coordinate must be a number!';
    }
    if (Number(newDeep) < 0) {
      return 'Vertical coordinate must greater than 0!';
    }
    const intError = !Number.isInteger(Number(newDeep));
    if (intError) {
      return 'Vertical coordinate must be a interger!';
    }
    if (except.includes(Number(newDeep))) {
      return ''
    }
    const { branch } = this.props;
    const column = branch[columnIndex];
    const exsitDeeps = column.map(item => item.number ? Array.from({ length: item.number }, (_, i) => Number(item.deep) + i) : [Number(item.deep)]).flat()
    const exsitError = exsitDeeps.includes(Number(newDeep));
    if (exsitError) {
      return 'Vertical coordinate has been occupied by other components, please re-enter!'
    }
    return ''
  }

  pcbIndexRender = (pcbIndex) => {
    const { selectkey } = this.state;
    const { shot } = this.props;
    return <Fragment>
      {
        pcbIndex.length > 1 && <div className='cascade-power-tree-pcb-name-title'>{
          pcbIndex.map((item, index) => <span
            key={item.key}
            className={`tree-tip ${index ? '' : 'tree-forbid-tip'} ${selectkey === item.key ? 'tree-select-tip' : ''}`}
            onClick={(e) => index ? this.changePCBKeys(e, item.key) : null}
          >
            {index ? '|' : ''}
            <ColorPicker
              value={item.color}
              className='tree-tip-color-picker'
              onChangeComplete={(value) => this.changeColor(value, index)}
              size='small'
              disabled={!index || shot}
            />
            <span style={{ backgroundColor: item.color }} className="tree-tip-name">{item.pcbName}</span>
          </span>)
        }</div>
      }
    </Fragment>
  }

  render() {
    const {
      id, branch, width: screenWidth, showLayout, running, showResult,
      pcbIndex = [], includeInd, whatIf, whatIfData, setting, mainPCB, resultStatus
    } = this.props;
    const { height, gridWidth, gridHeight, posUpdate, selectkey, width } = this.state;
    const existPCBNames = [mainPCB];
    return <div id={`power-tree-${id}`}>
      {this.pcbIndexRender(pcbIndex)}
      <div className='cascade-power-tree-canvas' id={`power-tree-layout-${id}`} style={width > screenWidth ? { overflowX: 'auto' } : { overflowX: 'hidden' }}>
        {branch.map((column, index) => {
          return column.map((item) => {
            let pcbName = undefined;
            const pcb = pcbIndex.find(p => p.key === item.pcbKey);
            if (!existPCBNames.includes(item.pcbKey) && pcb) {
              pcbName = pcb.pcbName;
              existPCBNames.push(pcb.key)
            }
            return <TreeComponent
              treeId={id}
              key={item.id}
              gridHeight={gridHeight}
              gridWidth={gridWidth}
              columnIndex={index}
              posUpdate={posUpdate}
              selectkey={selectkey}
              data={item}
              setting={setting}
              showResult={showResult}
              includeInd={includeInd}
              pcbName={pcbName}
              showLayout={showLayout}
              designId={pcb ? pcb.pcbId : null}
              resultStatus={resultStatus}
              whatIf={whatIf}
              whatIfData={whatIfData}
              running={running}
              //fn
              updatePosition={this.updatePosition}
              saveTreeItemValue={this.props.saveTreeItemValue}
              saveConnectorTreeItemValue={this.props.saveConnectorTreeItemValue}
              deleteTreeItem={this.props.deleteTreeItem}
              showTreeAction={this.props.showTreeAction}
              traceByComponent={this.props.traceByComponent}
              editTreeItem={this.props.editTreeItem}
              setTreeItemAsConnector={this.props.setTreeItemAsConnector}
              checkDeep={this.checkDeep}
              saveWhatIfData={this.props.saveWhatIfData}
            />
          })
        })}
        <canvas id={`power-tree-canvas-${id}`} className="power-tree-canvas" width={width} height={height} />
      </div>
    </div >
  }
}

export default TreeCanvas;